/* ============================================================
 * ADG Carousel — edge fade + chevrons for any horizontally
 * scrolling row. Extracted from the old monolithic home section
 * so every row section shares one implementation.
 *
 * Markup contract:
 *   .adg-home__carousel[data-hint]
 *     > [data-adg-prev]  (optional)
 *     > [data-adg-scroller]   <- the scrolling element
 *     > [data-adg-next]  (optional)
 *
 * Safe to load more than once: init is idempotent per element.
 * ============================================================ */
(function () {
  'use strict';

  function init(c) {
    if (c.dataset.adgCarouselReady === '1') return;
    var s = c.querySelector('[data-adg-scroller]');
    if (!s) return;
    c.dataset.adgCarouselReady = '1';

    var prev = c.querySelector('[data-adg-prev]');
    var next = c.querySelector('[data-adg-next]');

    function update() {
      var max = s.scrollWidth - s.clientWidth;
      if (max <= 2) {                       // nothing to scroll — hide the affordances
        s.removeAttribute('data-edge');
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      var x = s.scrollLeft;
      var edge = x <= 2 ? 'start' : (x >= max - 2 ? 'end' : 'both');
      s.setAttribute('data-edge', edge);
      if (prev) prev.hidden = (edge === 'start');
      if (next) next.hidden = (edge === 'end');
    }

    function step() {
      var card = s.firstElementChild;
      return card ? card.getBoundingClientRect().width + 18 : 300;
    }

    if (prev) prev.addEventListener('click', function () { s.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { s.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    s.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function boot() {
    document.querySelectorAll('.adg-home__carousel[data-hint]').forEach(init);
  }

  boot();
  // Theme Editor re-renders a section without a page load — re-init then too.
  document.addEventListener('shopify:section:load', boot);
})();
